import React, { FC, useContext, useMemo, useState } from 'react';

import { ITabOption, Tabs } from '@smartshell/ui-kit';

import { SettingsBlock, SettingsFrame } from 'components';
import { LocalizationContext } from 'localization';

import { ShellScreenSaver, SmartKiosk, SmartTV } from './components';
import s from './ScreenSavers.module.scss';

export const ScreenSavers: FC = () => {
  const { t } = useContext(LocalizationContext);

  const [tab, setTab] = useState<'shell' | 'smartKiosk' | 'smartTV'>('shell');

  const OPTIONS: Array<ITabOption<'shell' | 'smartKiosk' | 'smartTV'>> = [
    {
      title: 'Shell',
      value: 'shell',
    },
    {
      title: 'SmartKiosk',
      value: 'smartKiosk',
    },
    {
      title: 'SmartLock TV',
      value: 'smartTV',
    },
  ];

  const ContentTab = useMemo(() => {
    switch (tab) {
      case 'smartKiosk':
        return <SmartKiosk />;
      case 'smartTV':
        return <SmartTV />;
      case 'shell':
      default:
        return <ShellScreenSaver />;
    }
  }, [tab]);

  return (
    <SettingsBlock title={t('setting.shell.screensavers.title')}>
      <Tabs
        options={OPTIONS}
        onChange={setTab}
        value={tab}
        className={s.tabs}
      />
      <SettingsFrame>{ContentTab}</SettingsFrame>
    </SettingsBlock>
  );
};
